/**
 * @module Widget
 */

import { Component, Input } from '@angular/core';
import { WidgetLayersClass } from '@class/widgetLayers.class';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-widget-indicators-icon',
  templateUrl: './widget-indicators-icon.component.html',
  styleUrls: ['./widget-indicators-icon.component.css']
})
export class WidgetIndicatorsIconComponent {

  @Input() widgetLayers: WidgetLayersClass;
  @Input() current: number;

  color = ItemColor('indicators');

  constructor() {}

}
